export enum FilterHandlerResultType {
  ResultTypeRule = 'RESULT_TYPE_RULE',
  ResultTypeFundCollection = 'RESULT_TYPE_FUND_COLLECTION',
}
